var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{staticClass:"activity-panel"},[(_vm.t_data.length > 0)?_c('ul',{staticClass:"box"},_vm._l((_vm.t_data),function(item,i){return _c('li',{key:i,staticClass:"content"},[_c('img',{staticClass:"i",attrs:{"src":item.imgUrl || 'https://fakeimg.pl/250x250/F8F8F8/CCC/?text=Image&font=helvetica'}})])}),0):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }